import { useState, useEffect } from 'react';

export const useQuotations = () => {
  const [quotations, setQuotations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState({
    total: 0,
    pending: 0,
    accepted: 0,
    rejected: 0,
    expired: 0
  });

  useEffect(() => {
    // Mock data
    const mockQuotations = [
      { id: '1', status: 'pending', price: 1000 },
      { id: '2', status: 'accepted', price: 2000 },
      { id: '3', status: 'rejected', price: 1500 }
    ];
    
    setQuotations(mockQuotations);
    
    const stats = {
      total: mockQuotations.length,
      pending: mockQuotations.filter(q => q.status === 'pending').length,
      accepted: mockQuotations.filter(q => q.status === 'accepted').length,
      rejected: mockQuotations.filter(q => q.status === 'rejected').length,
      expired: mockQuotations.filter(q => q.status === 'expired').length
    };
    
    setStats(stats);
    setLoading(false);
  }, []);

  return { quotations, loading, stats };
};